import { TypedDocumentNode, gql } from '@apollo/client';

import { RepDifference as RepDifferenceDumb } from '@sorare/core/src/components/rivals/RepDifference';

import { RepDifference_footballRivalsGame } from './__generated__/index.graphql';

type Props = {
  rivalsGame: RepDifference_footballRivalsGame;
  showMyPotentialPointsDelta?: boolean;
};
export const RepDifference = ({
  rivalsGame,
  showMyPotentialPointsDelta,
}: Props) => {
  const { pointsDelta, myPotentialPointsDeltaWin, myPotentialPointsDeltaLoss } =
    rivalsGame;

  if (pointsDelta) {
    return (
      <RepDifferenceDumb
        win={pointsDelta > 0 ? pointsDelta : null}
        loss={pointsDelta <= 0 ? Math.abs(pointsDelta) : null}
      />
    );
  }
  if (
    showMyPotentialPointsDelta &&
    myPotentialPointsDeltaWin !== null &&
    myPotentialPointsDeltaLoss !== null
  ) {
    return (
      <RepDifferenceDumb
        win={myPotentialPointsDeltaWin}
        loss={Math.abs(myPotentialPointsDeltaLoss)}
      />
    );
  }

  return null;
};

RepDifference.fragments = {
  footballRivalsGame: gql`
    fragment RepDifference_footballRivalsGame on FootballRivalsGame {
      slug
      id
      pointsDelta(userSlug: $userSlug)
      myPotentialPointsDeltaWin
      myPotentialPointsDeltaLoss
    }
  ` as TypedDocumentNode<RepDifference_footballRivalsGame>,
};
